const quotationsTypes = {
  GET_EXPORT_DATA_REQUEST: "GET_EXPORT_DATA_REQUEST",
  GET_EXPORT_DATA_SUCCESS: "GET_EXPORT_DATA_SUCCESS",
  GET_EXPORT_DATA_FAILED: "GET_EXPORT_DATA_FAILED",
  GET_EXPORT_QUOTATIONS_REQUEST: "GET_EXPORT_QUOTATIONS_REQUEST",
  GET_EXPORT_QUOTATIONS_SUCCESS: "GET_EXPORT_QUOTATIONS_SUCCESS",
  GET_EXPORT_QUOTATIONS_FAILED: "GET_EXPORT_QUOTATIONS_FAILED",
  GET_ALL_QUOTATIONS: "GET_ALL_QUOTATIONS",
  GET_ALL_QUOTATIONS_SUCCESS: "GET_ALL_QUOTATIONS_SUCCESS",
  GET_ALL_QUOTATIONS_FAILED: "GET_ALL_QUOTATIONS_FAILED",
  GET_ALL_QUOTATIONS_DASHBOARD: "GET_ALL_QUOTATIONS_DASHBOARD",
  GET_ALL_QUOTATIONS_DASHBOARD_SUCCESS: "GET_ALL_QUOTATIONS_DASHBOARD_SUCCESS",
  GET_ALL_QUOTATIONS_DASHBOARD_FAILED: "GET_ALL_QUOTATIONS_DASHBOARD_FAILED",
  CREATE_QUOTATIONS: "CREATE_QUOTATIONS",
  CREATE_QUOTATIONS_SUCCESS: "CREATE_QUOTATIONS_SUCCESS",
  CREATE_QUOTATIONS_FAILED: "CREATE_QUOTATIONS_FAILED",
  GET_QUOTATIONS_ID: "GET_QUOTATIONS_ID",
  GET_QUOTATIONS_ID_SUCCESS: "GET_QUOTATIONS_ID_SUCCESS",
  GET_QUOTATIONS_ID_FAILED: "GET_QUOTATIONS_ID_FAILED",
  UPDATE_QUOTATIONS: "UPDATE_QUOTATIONS",
  UPDATE_QUOTATIONS_SUCCESS: "UPDATE_QUOTATIONS_SUCCESS",
  UPDATE_QUOTATIONS_FAILED: "UPDATE_QUOTATIONS_FAILED",
  UPDATE_QUOTATION_MANY: "UPDATE_QUOTATION_MANY",
  UPDATE_QUOTATION_MANY_SUCCESS: "UPDATE_QUOTATION_MANY_SUCCESS",
  UPDATE_QUOTATION_MANY_FAILED: "UPDATE_QUOTATION_MANY_FAILED",
  DELETE_QUOTATIONS: "DELETE_QUOTATIONS",
  DELETE_QUOTATIONS_SUCCESS: "DELETE_QUOTATIONS_SUCCESS",
  DELETE_QUOTATIONS_FAILED: "DELETE_QUOTATIONS_FAILED",
  GET_SUMMARY_QUOTATIONS: "GET_SUMMARY_QUOTATIONS",
  GET_SUMMARY_QUOTATIONS_SUCCESS: "GET_SUMMARY_QUOTATIONS_SUCCESS",
  GET_SUMMARY_QUOTATIONS_FAILED: "GET_SUMMARY_QUOTATIONS_FAILED",
  GET_CONCESSIONAIRES: 'GET_CONCESSIONAIRES',
  GET_CONCESSIONAIRES_SUCCESS: 'GET_CONCESSIONAIRES_SUCCESS',
  GET_CONCESSIONAIRES_FAILED: 'GET_CONCESSIONAIRES_FAILED',
  GET_EXCEL_QUOTATION: 'GET_EXCEL_QUOTATION',
  GET_EXCEL_QUOTATION_SUCCESS: 'GET_EXCEL_QUOTATION_SUCCESS',
  GET_EXCEL_QUOTATION_FAILED: 'GET_EXCEL_QUOTATION_FAILED',
}

export { quotationsTypes };